import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as _ from "lodash";

import { renderAdmin } from '../Common/Utilities';
import "./Teams.css"

class Teams extends Component {

    constructor(props) {
        super(props);
        this.renderTeamRows = this.renderTeamRows.bind(this);
        this.deleteTeam = this.deleteTeam.bind(this);
    }

    componentDidMount() {
        this.props.fetchAllTeams();
    }

    deleteTeam(id) {
        this.props.deleteTeam(id);
    }

    renderTeamRows(){
        let component = this;
        let teamListOutput = [];

        let teamList = _.map(this.props.teams, (team, index) => {
            return team;
        });

        if (!_.isEmpty(teamList)) {
            teamList.forEach(function (team) {
                let row = (
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 card-group mt-4">
                        <div className="card" key={team.id}>
                            <img className="card-img-top center-crop" src={team.imageURL} alt="Team" style={{width: '100%', height: '250px'}} />
                            <div className="card-body">
                                <h5 className="card-title">{team.teamName}</h5>
                                <h6 className="card-subtitle mb-2 text-muted">{team.owner}</h6>
                                <p className="card-text">{team.description}</p>
                                <Link className={"card-link btn btn-link " + renderAdmin(component.props.user.isAdmin)} to={`/create-team/${team.id}`}>Edit</Link>
                                <button className={"card-link btn btn-link" + renderAdmin(component.props.user.isAdmin)} onClick={()=>component.deleteTeam(team.id)}>Delete</button>
                            </div>
                        </div>
                    </div>
                );
                teamListOutput.push(row);
            });
        }
        return teamListOutput;

    }

    render() {

        return (
            <div>
                <h1>Teams</h1>
                <div className="row">
                    {this.renderTeamRows()}
                </div>
            </div>
        );
    }
}

export default Teams;



// WEBPACK FOOTER //
// ./src/components/Team/Teams.js